import React from 'react'
import PropTypes from 'prop-types'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import Container from '@material-ui/core/Container'
import Layout from '../Layout'
import Redeem from '../../../Component/Redeem'
import Referrals from '../../../Component/Referrals'
import WalletHistory from '../../../Component/WalletHistory'
import DashboardLayout from '../DashboardLayout'

const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `buyer-dashboard-${index}`,
        'aria-controls': `buyer-dashboard-tabpanel-${index}`,
    }
}

const Transactions = (props) => {
    const checkBidShopTheme = document.body.className == 'liquidationTwo bidShop'
    const [value, setValue] = React.useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    return (
        <>
            <Layout props={props}>
                {/* <div className="GFdashWrapperContainer"> */}
                <DashboardLayout title="My Reedem Page">
                    <div className="db-bids-wrapper">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="buyer-dashboard"
                            className="GFDashTabs"
                        >
                            <Tab
                                label={checkBidShopTheme ? 'Points' : 'Prime Points'}
                                {...a11yProps(0)}
                            />
                            <Tab label={'Referrals'} {...a11yProps(1)} />
                            <Tab label={'Wallet History'} {...a11yProps(2)} />
                        </Tabs>
                        <TabPanel value={value} index={0}>
                            <Container className="db-bids-wrapper mt-4 lq-db-table">
                                <Redeem />
                            </Container>
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <Container className="db-bids-wrapper mt-4 lq-db-table">
                                <Referrals />
                            </Container>
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <Container className="db-bids-wrapper mt-4 lq-db-table">
                                <WalletHistory />
                            </Container>
                        </TabPanel>
                    </div>
                </DashboardLayout>
                {/* </div> */}
            </Layout>
        </>
    )
}

export default Transactions
